module.exports = __webpack_public_path__ + "img/leader.57871c79.svg";